import React, { useState, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { translateFieldShiftFlag } from '../../helpers';

export const TextField = ({ row, label, maxLength = 20, inputFilter = null, onBackendSync = null }) => {
    const briefing = useSelector((state) => state.briefing.line);
    const [value, setValue] = useState(row[label]);
    const textareaRef = useRef(null);

    useEffect(() => {
        const checkAndResize = () => {
            const textarea = textareaRef.current;
            if (textarea && textarea.offsetParent !== null) { // visible
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            } else {
                setTimeout(checkAndResize, 100); // try again later
            }
        };

        checkAndResize();
    }, []);

    useEffect(() => {
        if (textareaRef.current) {
            // Adjust height
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [value]);

    const handleInputChange = (event) => {
        setValue(event.target.value);
    };

    const handleBlur = () => {
        if (value !== row[label]) {
            const tempMaxLength = maxLength + 1
            if (value.length < tempMaxLength) {
                if (!inputFilter || inputFilter.filter(value)) {
                    // Call the function to update the field in the backend
                    if (onBackendSync) {
                        onBackendSync(row.id, { [label]: value }).then(() => {
                            toast.success(`${label} updated successfully!`);
                        }).catch((error) => {
                            toast.error(error.response.data.msg || 'An error occurred');
                        });
                    }
                }
                else {
                    toast.error(inputFilter.message)
                }
            }
            else {
                toast.error('Text too long')
            }
        }
    }

    return (
        <>
            <textarea
                maxLength={maxLength}
                ref={textareaRef}
                className={`input autoExpand ${briefing === "Old Briefings" ? "disabled" : ""} ${translateFieldShiftFlag(row.shift_flag)}`}
                disabled={briefing === "Old Briefings"}
                value={value}
                onChange={handleInputChange}
                onBlur={handleBlur}
                placeholder="Hungry box"
                rows="1" // Start with one row
            />
        </>
    );
};

export const SelectField = ({ row, label, options, onBackendSync }) => {
    const briefing = useSelector((state) => state.briefing.line);
    const [value, setValue] = useState(row[label] || "");

    const handleChange = (event) => {
        setValue(event.target.value);
        if (onBackendSync) {
            onBackendSync(row.id, { [label]: event.target.value }).then(() => {
                toast.success(`${label} updated successfully!`);
            }).catch((error) => {
                toast.error(error.response.data.msg || 'An error occurred');
            });
        }
    };

    return (
        <select
            className={`input thin ${briefing === "Old Briefings" ? "disabled" : ""} ${translateFieldShiftFlag(row.shift_flag)}`}
            value={value}
            onChange={handleChange}
            disabled={briefing === "Old Briefings"}
        >
            <option value="">{`None`}</option>
            {options.map((option) => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
        </select>
    );
}